import { ONBOARDING_CONFIGURATIONS } from '../constants'

export const getOnboardingConfig = (
  onboardingStepName?: string,
  featureConfigName?: string,
  countryShortname?: string
) => {
  const stepConfig = ONBOARDING_CONFIGURATIONS[onboardingStepName]
  if (stepConfig == null) {
    return null
  }

  const featureConfig = stepConfig[featureConfigName]
  if (featureConfig == null) {
    return null
  }

  const configValue = featureConfig[countryShortname]
  if (configValue == null) {
    return featureConfig.default
  }

  return configValue
}
